import React from "react";
import {DatePicker, Space, Typography} from "antd"
import moment from "moment"
import {ArrowRightOutlined} from "@ant-design/icons"

const {Text} = Typography


export default class CalendarDataField extends React.Component {

    render() {
        const {edit, propertie, value, onChange, form} = this.props

        const range = Array.isArray(value)
        const defaultValue = range ? [moment(value[0]), moment(value[1])] : moment(value)
        var displayValue
        var mode
        var Component
        var withTime = false
        var format

        mode = "date"
        withTime = true
        format = "DD/MM/YYYY"
        Component = DatePicker
        if (range) {
            Component = Component.RangePicker
        }

        if (!edit) {
            if (range) {
                displayValue = (
                    <Space>{moment(value[0]).format(format)} <ArrowRightOutlined/> {moment(value[1]).format(format)}
                    </Space>)
            } else {
                displayValue = moment(value).format(format)
            }
            return <Text>{displayValue}</Text>
        }

        return (
            <Component
                style={{width: "100%"}}
                picker={mode}
                format={format}
                showTime={withTime}
                defaultValue={defaultValue}
                onChange={(v) => {
                    const changeValue = range ? [v[0].toDate(), v[1].toDate()] : v.toDate()
                    onChange(changeValue)
                }}
            />
        )


    }
}
